
export default {
    getPageList: {
        config: {
            url: 'demo/page/list',
            method: 'get'
        }
    }
}